export default "__VITE_ASSET__69eb3866__"